import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import CheckIcon from '@material-ui/icons/Check';
import { withStyles } from '@material-ui/core/styles/index';
import compose from 'recompose/compose';

const styles = (theme) => ({
  labelStyle: {
    color: theme.palette.text.secondary,
  },
});

class MiniDatasetPicker extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
    };
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuItemClick = (value) => {
    this.setState({ anchorEl: null });
    if (this.props.onChange && value) {
      this.props.onChange(value);
    }
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { anchorEl } = this.state;
    const { datasets, dataset, classes, id } = this.props;
    return (
      <>
        <Button
          classes={this.props.labelStyle || { label: classes.labelStyle }}
          aria-owns={anchorEl ? 'dataset-menu' : null}
          aria-haspopup="true"
          onClick={this.handleClick}
          style={{ height: '100%' }}
          id={id}
        >
          {this.props.label || 'CHANGE'}
        </Button>
        <Menu
          id="dataset-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
        >
          {datasets.valueSeq().map((theDataset, index) => (
            <MenuItem
              button
              key={theDataset.id}
              selected={dataset === theDataset}
              onClick={() => this.handleMenuItemClick(theDataset)}
            >
              <ListItemIcon
                style={{
                  visibility: `${dataset === theDataset ? 'visible' : 'hidden'}`,
                  marginRight: 0,
                }}
              >
                <CheckIcon />
              </ListItemIcon>
              <ListItemText primary={theDataset.name} id={index === 0 ? 'my-account-1st-data-set' : ''} />
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  }
}

MiniDatasetPicker.propTypes = {
  dataset: PropTypes.any.isRequired,
  datasets: PropTypes.any.isRequired,
  label: PropTypes.string,
  labelStyle: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string,

  classes: PropTypes.object,
};

export default compose(
  withStyles(styles, { name: 'MiniDatasetPicker', withTheme: true }),
)(MiniDatasetPicker);
